import Vue from 'vue'
import { AdminConfig, AdminPageHeader } from 'stylemix-vue-admin'
import Layout from '../components/Layout'
import Axios from 'axios'
import logo from '../../../console/src/assets/images/taxi-logo.png'

AdminConfig.setLogo(logo)
AdminConfig.setDefaultRoute({
  name: 'bookings',
})

AdminConfig.useAxios()
AdminConfig.useAlerts()
AdminConfig.useAuth({
  storagePrefix: `${process.env.VUE_APP_STORAGE_PREFIX}-personal`,
  registerForm: () => import('../auth/RegisterForm'),
})

// For convenience add frequently used components as global
Vue.component('layout', Layout)
Vue.component('page-header', AdminPageHeader)

Axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 403) {
      Vue.$toast.warning(error.response.data.message)
    }

    return Promise.reject(error)
  },
)
